// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { linea as _linea } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the linea chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 59144
 * Chain Name: Linea Mainnet
 * Default Block Explorer: https://lineascan.build
 * Default RPC URL: https://rpc.linea.build
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { linea } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: linea,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const linea = createCommon({
	..._linea,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
